import { keys, reduce, isNil } from 'lodash';
import { Validations, Helpers } from '@utils/helpers';
import { BasicDetailsForm } from '@models/MLTC/BasicDetails.model';
import { IError } from '@utils/useForm';

export const validate = (values: BasicDetailsForm) => {
  const fields = keys(values);
  const errors: any = reduce(
    fields,
    (result, field: string) => {
      return { ...result, [field]: validateField(values, field) };
    },
    {}
  );
  return errors;
};

export enum EErrorCode {
  none = 'none',
  emptyValue = 'emptyValue',
  ivalidDoBFormat = 'ivalidDoBFormat',
  outOfAgeRange = 'outOfAgeRange',
}

export const validateField = (values: any, name: string) => {
  const value = values[name];
  let error: IError & {errorCode: EErrorCode} | undefined = { isValid: true, errorCode: EErrorCode.none };
  switch (name) {
    case 'dob':
      const minAge = 31,
        maxAge = 65;
      const { day, month, year } = value;
      const stringDate = `${month}/${day}/${year}`;
      
      if (isNil(year) || (isNil(day) || isNil(month))) {
        error = { isValid: false, errorCode: EErrorCode.emptyValue };
      }
      else {
        if((!isNil(year) && year.length>=4) && (!isNil(month) && month.length>=2) && (!isNil(day) && day.length>=2))
        {
          if (Validations.isValidDayOfBirth(stringDate) && Number(year) > 10) {
            const refDay = new Date(stringDate);
            const aged = Helpers.getAge(refDay);
            const isInRange: number = Validations.isInRange(aged, minAge, maxAge);
            if (isInRange !== 0) {
              error = {
                errorCode: EErrorCode.outOfAgeRange,
                isValid: true,
              };
            }
          } else {
            error = {
              errorCode: EErrorCode.ivalidDoBFormat,
              isValid: true,
              message:
                'Oops, seems like your Date of Birth is incorrect, please try again',
            };
          }
        }
        else
        {
          error = { isValid: false, errorCode: EErrorCode.emptyValue };

        }
      }
      break;
    case 'gender':
  }
  return error;
};
